"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumeItemSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var TextArea_1 = __importDefault(require("antd/lib/input/TextArea"));
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var formik_1 = require("formik");
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Yup = __importStar(require("yup"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var productsList_1 = require("common/global/productsList");
var warehouseConsumeOperationsSlice_1 = require("src/features/warehouseConsumeOperations/warehouseConsumeOperationsSlice");
var Option = antd_1.Select.Option;
exports.ConsumeItemSchema = Yup.object().shape({
    productId: Yup.string().required(),
    projectId: Yup.string().required(),
    stockNumber: Yup.string().required(),
    quantity: Yup.number().required(),
});
function ConsumeItemDialog(props) {
    var _a;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var modalState = props.modalState, warehouseItems = props.warehouseItems, setModalState = props.setModalState;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), uploading = _b[0], setUploading = _b[1];
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            productId: "",
            projectId: "",
            stockNumber: undefined,
            quantity: 1,
            serialNumbers: [],
            notes: "",
        },
        validationSchema: exports.ConsumeItemSchema,
        onSubmit: function (values, form) {
            var _a, _b, _c;
            var product = productsList_1.globalProductsData[values.productId];
            var sameProducts = warehouseItems.find(function (x) {
                return x.stockNumber === values.stockNumber &&
                    x.productId === values.productId &&
                    x.projectId === values.projectId;
            });
            var _d = lodash_1.zip.apply(void 0, ((_a = values.serialNumbers) !== null && _a !== void 0 ? _a : []).map(function (x) { return x.split(":"); })), serialNumbers = _d[0], assetsNumbers = _d[1];
            var quantity = product.serialNumbered ? 1 : values.quantity;
            if (quantity === 0) {
                throw new Error("QuantityMustBePositive");
            }
            var userId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
            dispatch((0, warehouseConsumeOperationsSlice_1.consumeWarehouseItem)({
                item: __assign(__assign({}, values), { projectId: values.projectId, productId: values.productId, stockNumber: values.stockNumber, batchNumber: sameProducts.batchNumber, warehouseId: props.warehouseId, budgetLineId: sameProducts.budgetLineId, expiryDate: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.expiryDate, dnNumber: (_b = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.dnNumber) !== null && _b !== void 0 ? _b : "", from: (_c = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.from) !== null && _c !== void 0 ? _c : "", id: sameProducts.id, quantity: sameProducts.quantity }),
                product: product,
                quantity: quantity,
                serialNumbers: product.serialNumbered ? serialNumbers : [],
                assetsNumbers: product.serialNumbered ? assetsNumbers : [],
                userId: userId,
            }))
                .then(function () {
                antd_1.message.success(t("alerts.success"));
                setModalState(undefined);
                form.resetForm();
            })
                .catch(function (e) {
                console.log(e);
                if (e.message === "QuantityMustBePositive") {
                    antd_1.message.error("Quantity must be positive");
                }
                else {
                    antd_1.message.error(t("alerts.error"));
                }
            });
            // dispatch(
            //   addConsumeOperation(
            //     removeUndefined({
            //       warehouseId: props.warehouseId,
            //       projectId: values.projectId,
            //       productId: values.productId,
            //       stockNumber: values.stockNumber,
            //       batchNumber: sameProducts.batchNumber,
            //       serialNumbers: product.serialNumbered ? serialNumbers : [],
            //       assetsNumbers: product.serialNumbered ? assetsNumbers : [],
            //       quantity: quantity,
            //       createdAt: moment() as any,
            //       updatedAt: moment() as any,
            //       cachedProductName: product.name,
            //       cachedProductUnit: product.unitId,
            //       cachedProductDescription: product.description,
            //       notes: values.notes ?? "",
            //       consumedBy: userId,
            //       cachedProductCategory: product.categoryId,
            //       budgetLineId: sameProducts.budgetLineId,
            //       expiryDate: sameProducts?.expiryDate,
            //       dnNumber: sameProducts?.dnNumber ?? "",
            //       from: sameProducts?.from ?? "",
            //       before: sameProducts.quantity,
            //       after: sameProducts.quantity - quantity,
            //     } as WarehouseConsumeOperation)
            //   )
            // );
            // const newQuantity = sameProducts.quantity - quantity;
            // if (newQuantity < 0) {
            //   message.error("الكمية المصروفة اكبر من الكمية الحالية!");
            // } else {
            //   dispatch(
            //     editWarehouseItem({
            //       id: sameProducts.id,
            //       quantity: newQuantity,
            //       serialNumbers: sameProducts?.serialNumbers
            //         ? sameProducts?.serialNumbers?.filter(
            //             (x) => !serialNumbers.includes(x)
            //           )
            //         : [], // TODO: no need to delete one of the serialnumbers
            //       assetsNumbers: sameProducts?.assetsNumbers
            //         ? sameProducts?.assetsNumbers?.filter(
            //             (x) => !assetsNumbers.includes(x)
            //           )
            //         : [],
            //     } as WarehouseItem)
            //   )
            //     .then(() => {
            //       message.success(t("alerts.success"));
            //       setModalState(undefined);
            //       form.resetForm();
            //     })
            //     .catch((e) => {
            //       console.log(e);
            //       if (e.message === "QuantityMustBePositive") {
            //         message.error("Quantity must be positive");
            //       } else {
            //         message.error(t("alerts.error"));
            //       }
            //     });
            // }
            // })
        },
    });
    var sameProducts = warehouseItems.find(function (x) {
        return x.stockNumber === formProps.values.stockNumber &&
            x.productId === formProps.values.productId &&
            x.projectId === formProps.values.projectId;
    });
    var product = productsList_1.globalProductsData[formProps.values.productId];
    var max = (_a = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.quantity) !== null && _a !== void 0 ? _a : 0;
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, __assign({ title: "Consume Item", open: modalState, onOk: function () {
            if (product.serialNumbered) {
                formProps.setFieldValue("quantity", 1);
            }
            formProps.submitForm();
        }, okButtonProps: { disabled: uploading }, onCancel: function () { return setModalState(undefined); }, confirmLoading: formProps.isSubmitting }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("productId").touched) &&
                        formProps.errors.productId &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("productId").touched) &&
                        formProps.errors.productId, label: t("common.product") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: formProps.values.productId, onSelect: function (e) {
                            formProps.setFieldValue("productId", e);
                            formProps.setFieldValue("projectId", undefined);
                            formProps.setFieldValue("quantity", undefined);
                            formProps.setFieldValue("stockNumber", undefined);
                            formProps.setFieldValue("notes", undefined);
                        } }, { children: (0, lodash_1.uniqBy)(warehouseItems.filter(function (e) {
                            if (e.type == "asset") {
                                return e.quantity > 0;
                            }
                            else {
                                return e.quantity > 0 && (0, moment_1.default)(e.expiryDate) >= (0, moment_1.default)();
                            }
                        }), "productId").map(function (item, key) {
                            var _a;
                            var unit = (_a = unitsList_1.globalUnitsData[item.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name;
                            return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: item.productId }, { children: "".concat(item.cachedProductName, "/ ").concat(item.cachedProductDescription, "/ ").concat(unit) }), key));
                        }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("projectId").touched) &&
                        formProps.errors.projectId &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("projectId").touched) &&
                        formProps.errors.projectId, label: t("common.project") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: formProps.values.projectId, onSelect: formProps.handleChange("projectId") }, { children: (0, lodash_1.uniqBy)(warehouseItems
                            .filter(function (e) {
                            if (e.type == "asset") {
                                return e.quantity > 0;
                            }
                            else {
                                return e.quantity > 0 && (0, moment_1.default)(e.expiryDate) >= (0, moment_1.default)();
                            }
                        })
                            .filter(function (x) { return x.productId === formProps.values.productId; }), "projectId").map(function (item) {
                            return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: item.projectId }, { children: projectsList_1.globalProjectsData[item.projectId].code }), item.projectId));
                        }) })) })), formProps.values.productId && formProps.values.projectId ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("stockNumber").touched) &&
                        formProps.errors.stockNumber &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("stockNumber").touched) &&
                        formProps.errors.stockNumber, label: t("warehouse.stockNumber") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ maxTagCount: 1, value: formProps.values.stockNumber, onChange: function (e) {
                            formProps.setFieldValue("stockNumber", e);
                        } }, { children: warehouseItems
                            .filter(function (e) {
                            if (e.type == "asset") {
                                return e.quantity > 0;
                            }
                            else {
                                return e.quantity > 0 && (0, moment_1.default)(e.expiryDate) >= (0, moment_1.default)();
                            }
                        })
                            .filter(function (x) {
                            return x.productId === formProps.values.productId &&
                                x.projectId === formProps.values.projectId &&
                                x.stockNumber;
                        })
                            .map(function (x) { return ((0, jsx_runtime_1.jsx)(antd_1.Select.Option, __assign({ value: x.stockNumber }, { children: x.stockNumber }), x.stockNumber)); }) })) }))) : null, product && !product.serialNumbered ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("quantity").touched) &&
                        formProps.errors.quantity &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("quantity").touched) &&
                        formProps.errors.quantity, label: t("common.quantity") }, { children: (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { type: "number", max: isNaN(max) ? 0 : max, min: 0, value: formProps.values.quantity, onChange: function (e) { return formProps.setFieldValue("quantity", e); } }) }))) : null, product && product.serialNumbered ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("serialNumbers").touched) &&
                        formProps.errors.serialNumbers &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("serialNumbers").touched) &&
                        formProps.errors.serialNumbers, label: t("warehouse.serialNumbers") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ value: formProps.values.serialNumbers, onChange: function (e) { return formProps.setFieldValue("serialNumbers", e); }, mode: "multiple" }, { children: warehouseItems
                            .filter(function (x) {
                            return x.productId === formProps.values.productId &&
                                x.projectId === formProps.values.projectId &&
                                x.stockNumber === formProps.values.stockNumber;
                        })
                            .map(function (x) {
                            return x.serialNumbers.map(function (serial, idx) { return ((0, jsx_runtime_1.jsxs)(antd_1.Select.Option, __assign({ value: "".concat(serial, ":").concat(x.assetsNumbers[idx]) }, { children: [serial, "/", x.assetsNumbers[idx]] }), serial)); });
                        }) })) }))) : null, (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes, label: t("common.notes") }, { children: (0, jsx_runtime_1.jsx)(TextArea_1.default, { value: formProps.values.notes, onChange: formProps.handleChange("notes") }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes })] })) })));
}
exports.default = ConsumeItemDialog;
